import { createFileRoute, redirect } from '@tanstack/react-router'

export const Route = createFileRoute('/_manage/manage/admin/')({
  beforeLoad: () => {
    throw redirect({ to: '/manage/admin/dashboard' })
  },
  component: () => null,
})


